import './polls.less';

App.Pages.PollsEnd = class PollsEnd extends PF.Page
{

	static get options()
	{
		return {
			rights: {
				guest: true,
				user: true
			},
			panel: false,
			path: '/poll-end',
			nameRu: 'Опрос - завершение',
		};
	}

	static get template()
	{
		//language=HTML
		return /*html*/`
            <div class="page polls">
				<div class="page-content" pf="pageContent">
					<div class="row" style="margin-top: 130px;">
                        <div class="col-100" style="text-align: center;">
							<img class="logo" src="/img/Служба крови лого.svg"/>
						</div>
					</div>
					<div class="row" style="margin-top: 140px;">
                        <div class="col-100" style="text-align: center;">
							<h1>Благодарим за участие в опросе!<br>
								Вы сделали важный шаг в наше развитие!</h1>
						</div>
					</div>
					<div class="row" style="margin-top: 50px;">
                        <div class="col-25"></div>
                        <div class="col-50">
							<button class="button button-end" type="button" pf="buttonPolls">На главную</button><br/>
						</div>
                        <div class="col-25"></div>
					</div>
				</div>
			</div>
		`;
	}

	init()
	{
		super.init();
		if (this.user === null || this.user === undefined)
		{
			app.panelState = null;
		} else
		{
			app.panelDisplay(0);
		}
		this.dom.pageContent.css('height', '100%');
		//
		this.time = setTimeout(this.logout, 10 * 1000);
		this.dom.buttonPolls.on("click", () =>
		{
			clearTimeout(this.time);
			app.router.navigate('/polls');
		});
	}

	logout()
	{
		app.router.navigate('/polls');
	}
};